var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED5565;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#F5BB41;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 40,
    cy: 40,
    r: 40
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,0h97.4c6,0,10.8,4.9,10.8,10.9v58.2c0,6-4.8,10.9-10.8,10.9H10.8C4.8,80,0,75.1,0,69.1V10.9 C0,4.9,4.8,0,10.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,43.8c-1.4,1-2.2,0.4-1.8-1.2l1.5-6.3c0.4-1.7-0.3-4-1.6-5.1l-4.6-4c-1.3-1.1-1-2.1,0.8-2.1l6.4-0.2 c1.7,0,3.5-1.5,4-3.1l2-6.8c0.5-1.7,1.4-1.7,1.9-0.1l2.4,6.8c0.6,1.6,2.5,3,4.2,3l6.5,0.1c1.7,0,2.1,1,0.8,2.1l-5,4.4 c-1.3,1.1-2,3.4-1.5,5.1l1.6,5.5c0.5,1.7-0.3,2.3-1.8,1.4L28,39.8c-1.5-0.9-3.8-0.8-5.2,0.2L17.5,43.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.7,17.3c-0.5,0.4-0.8,0.2-0.6-0.4l0.5-2.2c0.1-0.6-0.1-1.4-0.5-1.8l-1.5-1.4c-0.4-0.4-0.3-0.7,0.3-0.7 l2.2-0.1c0.6,0,1.2-0.5,1.4-1.1l0.7-2.4c0.2-0.6,0.5-0.6,0.7,0l0.8,2.3c0.2,0.6,0.8,1,1.4,1l2.2,0c0.6,0,0.7,0.3,0.3,0.7l-1.7,1.5 c-0.4,0.4-0.7,1.2-0.5,1.8l0.5,1.9c0.2,0.6-0.1,0.8-0.6,0.5l-1.8-1.1c-0.5-0.3-1.3-0.3-1.8,0.1L46.7,17.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.7,49.2c-0.5,0.4-0.8,0.2-0.6-0.4l0.5-2.2c0.1-0.6-0.1-1.4-0.5-1.8l-1.5-1.4c-0.4-0.4-0.3-0.7,0.3-0.8 l2.2-0.1c0.6,0,1.2-0.5,1.4-1.1l0.7-2.4c0.2-0.6,0.5-0.6,0.7,0l0.8,2.4c0.2,0.6,0.8,1,1.4,1l2.2,0c0.6,0,0.7,0.3,0.3,0.7l-1.7,1.5 c-0.4,0.4-0.7,1.2-0.5,1.8l0.5,1.9c0.2,0.6-0.1,0.8-0.6,0.5l-1.8-1.1c-0.5-0.3-1.3-0.3-1.8,0L46.7,49.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.4,40.1c-0.5,0.3-0.8,0.2-0.6-0.4l0.5-2.2c0.1-0.6-0.1-1.4-0.5-1.8l-1.5-1.4c-0.4-0.4-0.3-0.7,0.2-0.8 l2.2-0.1c0.6,0,1.2-0.5,1.3-1.1l0.7-2.4c0.2-0.6,0.5-0.6,0.7,0l0.8,2.3c0.2,0.6,0.8,1,1.4,1l2.2,0c0.6,0,0.7,0.3,0.2,0.7l-1.7,1.5 c-0.4,0.4-0.7,1.2-0.5,1.8l0.5,1.9c0.2,0.6-0.1,0.8-0.6,0.5L62,38.7c-0.5-0.3-1.3-0.3-1.8,0.1L58.4,40.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.4,27.9c-0.5,0.4-0.8,0.1-0.6-0.4l0.5-2.2c0.1-0.6-0.1-1.4-0.5-1.8l-1.5-1.4c-0.4-0.4-0.3-0.7,0.2-0.7 l2.2-0.1c0.6,0,1.2-0.5,1.3-1.1l0.7-2.4c0.2-0.6,0.5-0.6,0.7,0l0.8,2.3c0.2,0.6,0.8,1,1.4,1l2.2,0c0.6,0,0.7,0.3,0.2,0.7l-1.7,1.5 c-0.4,0.4-0.7,1.2-0.5,1.8l0.5,1.9c0.2,0.6-0.1,0.8-0.6,0.5L62,26.5c-0.5-0.3-1.3-0.3-1.8,0.1L58.4,27.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.2f49cb2698a14d53596439393c403c75.svg";
export { ForwardRef as ReactComponent };